enum FormType {
  social = 'social',
  language = 'language',
  grossMotor = 'gross_motor',
  fineMotor = 'fine_motor',
  selfEsteem = 'self-esteem'
}

export const formTypes = [
  FormType.social,
  FormType.language,
  FormType.fineMotor,
  FormType.grossMotor,
  FormType.selfEsteem
]

export enum BaseFormAssessments {
  social = 'social',
  motor = 'motor',
  selfEsteem = 'self-esteem',
  language = 'language'
}

export const formTypeToAssessment = {
  [FormType.social]: BaseFormAssessments.social,
  [FormType.grossMotor]: BaseFormAssessments.motor,
  [FormType.fineMotor]: BaseFormAssessments.motor,
  [FormType.selfEsteem]: BaseFormAssessments.selfEsteem,
  [FormType.language]: BaseFormAssessments.language
}

export const formTypeRefs = {
  [FormType.social]: 'social',
  [FormType.grossMotor]: 'motor.gross_motor',
  [FormType.fineMotor]: 'motor.fine_motor',
  [FormType.selfEsteem]: 'self-esteem',
  [FormType.language]: 'language'
}

export const baseFormAssessments = [
  BaseFormAssessments.social,
  BaseFormAssessments.motor,
  BaseFormAssessments.selfEsteem,
  BaseFormAssessments.language
]

export const baseFormRefs = [
  formTypeRefs[FormType.social],
  formTypeRefs[FormType.grossMotor],
  formTypeRefs[FormType.fineMotor],
  formTypeRefs[FormType.selfEsteem],
  formTypeRefs[FormType.language]
]

interface IQuestionnairesInTalentMapKeys {
  [questionnarie: string]: string[]
}

export const questionnairesInCurrentTalentMap: IQuestionnairesInTalentMapKeys = {
  [BaseFormAssessments.social]: [
    'prosocial',
    'emotional_symptoms',
    'conduct_problems',
    'peer_problems'
  ],
  [BaseFormAssessments.selfEsteem]: ['social', 'emotional'],
  [BaseFormAssessments.language]: [
    'social_emotional',
    'listening',
    'writing',
    'reading',
    'speaking'
  ],
  [BaseFormAssessments.motor]: ['fine_motor', 'gross_motor']
}

export default FormType



// WEBPACK FOOTER //
// ./src/data/questionnaires/FormType.ts